import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const DefaultRedirect: React.FC = () => {
  const { token, user } = useAuth();
  
  // Si l'utilisateur est connecté
  if (token) {
    // Si l'utilisateur a le rôle "user", rediriger vers overview
    if (user?.role === 'user') {
      return <Navigate to="/overview" replace />;
    }
    // Sinon, rediriger vers dashboard (admin/moderator)
    return <Navigate to="/dashboard" replace />;
  }
  
  // Sinon, rediriger vers signin
  return <Navigate to="/signin" replace />;
};

export default DefaultRedirect; 